import React from 'react';
import { cssColorValue, desktopFinale, desktopFinaleBold, desktopMesto, desktopMestoBold, screenMdMin, screenSmMax, spacer12, spacer16, spacer24, spacer32, } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { FooterTextLink } from './Link';
import { isMastheadLinkList, isMastheadLinkListItem, } from '../../utils/contentful';
import { trackingAttributes } from '../../lib/buildTrackingAttributes';
import { useS4AMastheadContext } from '../S4AMastheadProvider';
import { isNotUndefined } from '../../lib/isNotUndefined';
const CopyrightPolicies = styled.div `
  flex: none;
  order: 0;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: calc(${spacer24} + ${spacer12});
  @media (max-width: ${screenSmMax}) {
    width: 100%;
    justify-content: space-between;
    gap: ${spacer24};
    order: 1;
    align-self: stretch;
  }
`;
const CopyrightWrapper = styled.div `
  color: ${props => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.secondaryText) !== null && _b !== void 0 ? _b : cssColorValue('textSubdued'); }};
  ${() => desktopFinale};
  @media (min-width: ${screenMdMin}) {
    ${() => desktopMesto}
  }
`;
const PoliciesWrapper = styled.div `
  display: flex;
  align-items: center;
  gap: ${spacer16};
  @media (min-width: ${screenMdMin}) {
    gap: ${spacer32};
  }
`;
const StyledPolicyLink = styled(FooterTextLink) `
  && {
    ${desktopFinaleBold};
    @media (min-width: ${screenMdMin}) {
      ${desktopMestoBold}
    }
  }
`;
const copyrightYear = new Date().getFullYear();
export const FooterCopyrightPolicies = ({ colors, footerEntry }) => {
    const { trackCat } = useS4AMastheadContext();
    return (React.createElement(CopyrightPolicies, null,
        React.createElement(CopyrightWrapper, { colors: colors },
            "\u00A9 ",
            copyrightYear,
            " Spotify AB"),
        footerEntry.fields.corporateLinks
            .filter(isNotUndefined)
            .filter(isMastheadLinkList)
            .map((item, i) => {
            const links = (item.fields.entries || [])
                .filter(isMastheadLinkListItem)
                .map(entry => {
                const link = entry.fields.mastheadLink;
                return {
                    openInNewWindow: link.fields.target === 'blank',
                    href: link.fields.href,
                    title: link.fields.title,
                    track: trackingAttributes(trackCat, link.fields.trackingId),
                };
            });
            return (React.createElement(PoliciesWrapper, { key: `${item.fields.label}-${i}` }, links.map(link => (React.createElement(StyledPolicyLink, { key: link.title, href: link.href, track: link.track, colors: colors, openInNewWindow: link.openInNewWindow }, link.title)))));
        })));
};
//# sourceMappingURL=CopyrightPolicies.js.map